<template>
    <div>
        <div class="page-header">
            <div>CUSTOMERS</div>
            <p/>
        </div>
        <div class="header">
            <div class="form__group">
                <label class="label--search">Search</label>
                <Search
                    class="input input__round input--search"
                    placeholder="Search..."
                    @on-value-change="searchValueChanged"
                />
            </div>
            <Button class="btn btn__primary" text="New Customer" @on-click="goToCreatePage"/>
        </div>
        <div class="card">
            <table class="has-links" style="width:100%">
                <col width="10%">
                <col width="30%">
                <col width="20%">
                <col width="20%">
                <col width="20%">
                <tr>
                    <SortItem title="Customer ID" @set-sort="setSort" sortKey="id" :sort="sort"/>
                    <SortItem title="Name" @set-sort="setSort" sortKey="name" :sort="sort"/>
                    <SortItem title="Phone" @set-sort="setSort" sortKey="phone" :sort="sort"/>
                    <SortItem title="Created at" @set-sort="setSort" sortKey="created_at" :sort="sort"/>
                    <SortItem title="Updated at" @set-sort="setSort" sortKey="updated_at" :sort="sort"/>
                </tr>
                <tr
                    v-for="customer in customers.data"
                    :key="customer.id"
                    class="table-row"
                    @click="goToDetails(customer)"
                >
                    <td class="customer-id">{{customer.id}}</td>
                    <td>{{customer.name}}</td>
                    <td>{{customer.phone}}</td>
                    <td>{{moment(customer.created_at).format('DD.MM.YYYY HH:MM')}}</td>
                    <td>{{moment(customer.updated_at).format('DD.MM.YYYY HH:MM')}}</td>
                </tr>
            </table>
        </div>
        <div v-if="customers.last_page && customers.last_page > 1" class="paginate__wrapper">
            <paginate
                :page-count="customers.last_page || 1"
                :prev-text="'Prev'"
                :click-handler="onPageChange"
                :next-text="'Next'"
                :container-class="'paginate'"
            ></paginate>
        </div>
    </div>
</template>

<script>
    import Search from "../partials/Search.vue";
    import SortItem from "../partials/SortItem.vue";
    import Button from "../partials/Button.vue";
    import moment from "moment";
    import Paginate from "vuejs-paginate";
    import * as api from "./api.js";

    export default {
        name      : "CustomerList",
        components: {
            Search,
            Button,
            Paginate,
            SortItem
        },
        created   : async function () {
            this.fetchCustomers();
            document.title = "Customers | PayGate Invoice";
        },
        methods   : {
            goToDetails(customer) {
                this.$router.push(`customers/${customer.id}`);
            },
            setSort(sort) {
                if (this.sort.value == sort) {
                    if (this.sort.direction == "asc") {
                        this.sort.direction = "desc";
                    } else {
                        this.sort.direction = "asc";
                    }
                } else {
                    this.sort.value = sort;
                    this.sort.direction = "asc";
                }
                this.fetchCustomers();
            },
            goToCreatePage() {
                this.$router.push(`customers/create`);
            },
            searchValueChanged: async function (search) {
                this.search = search;
                this.page = 1;
                this.fetchCustomers();
            },
            onPageChange      : async function (page) {
                this.page = page;
                this.fetchCustomers();
            },
            fetchCustomers    : async function () {
                this.customers = await api.fetchCustomers({
                    search: this.search,
                    page  : this.page,
                    sort  : this.sort
                });
            }
        },
        data() {
            return {
                page     : 1,
                moment   : moment,
                customers: {},
                search   : "",
                sort     : {
                    value    : "created_at",
                    direction: "desc"
                }
            };
        }
    };
</script>

<style lang="scss" scoped>
    .button {
        width: 150px;
    }

    .header {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
    }

    .customer-id {
        /*padding-left: 50px;*/
    }
</style>
